module.exports = __webpack_public_path__ + "static/media/logo-no-icon.c2ae2626.svg";